<template>
  <div class="edit__form">
    <label class="edit__form-label">アイテム</label>
    <div class="edit__form-input" style="display: flex; flex-direction: column; gap: 5px; align-items: flex-start">
      <div v-for="item in items" :key="item.index" style="display: flex; gap: 5px; align-items: center; width: 100%">
        <div style="flex: 1">
          <select :ref="(el) => el && (selectRefs[item.index] = el)" :name="`${name}[item_id][]`"></select>
        </div>
        <button class="edit__button" type="button" @click="removeItem(item.index)">削除</button>
      </div>
      <button class="edit__button" type="button" @click="addItem">追加</button>
      <small class="edit__form-explain">商品に関連するアイテムを指定します。</small>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue';
import TomSelect from 'tom-select';

const props = defineProps({
  // フォームフィールドのプレフィックス（例: single_product / gift_product）
  name: {
    type: String,
    required: true,
  },
  // 初期表示する関連アイテム（[{ id, name }, ...]）
  initialItems: {
    type: Array,
    default: () => [],
  },
});

const items = ref([]);
const selectRefs = reactive({});
let nextIndex = 0;

function initSelects() {
  nextTick(() => {
    items.value.forEach((item) => {
      const el = selectRefs[item.index];
      if (!el || el.tomselect) return;

      const ts = new TomSelect(el, {
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        load: function (query, callback) {
          if (!query.length) return callback();

          fetch(`/search_api/items/code/name?q=${encodeURIComponent(query)}`)
            .then((res) => res.json())
            .then(callback)
            .catch(() => callback([]));
        },
        create: false,
        maxOptions: 10,
      });

      // 初期 option を追加・選択
      if (item.id && item.name) {
        ts.addOption({ id: item.id, name: item.name });
        ts.setValue(item.id);
      }
    });
  });
}

// 初期化
onMounted(() => {
  console.log(props.initialItems);
  items.value = props.initialItems.map((item, index) => ({
    index: index,
    id: item.id,
    name: item.name,
  }));
  nextIndex = items.value.length;
  initSelects();
});

// 追加
function addItem() {
  items.value.push({ index: nextIndex++, id: '', name: '' });
  initSelects();
}

// 削除
function removeItem(index) {
  const el = selectRefs[index];
  if (el && el.tomselect) el.tomselect.destroy();
  delete selectRefs[index];
  items.value = items.value.filter((item) => item.index !== index);
}
</script>
